import React, { useEffect, useState, useContext } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { DialogAction, useModal } from '../../../../function/useModal';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
} from '@material-ui/core';
import { AppContext } from '../../../../App';
import dayjs from 'dayjs';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import TimeEntry from '../../../atoms/Input/TimeEntry';
import SimpleDialog from '../../../atoms/Dialog/SimpleDialog';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableUseStyle, ConanairManagementStyle } from './ConanairManagementStyle';
import { CONNAIR_SET, InsertConanAirManagement, ApiResponseCode, ConanAirSetModel, ColSetLogModel } from './ConanairManagement';


export type ConanairManagementGridRowNewDialogProps = {
  dialog: DialogAction<ConanairManagementGridRowNewDialogResponse>;
  devNoComBox: ComboBoxItemType[];
  nameItemComBox: ComboBoxItemType[];
};

export type ConanairManagementGridRowNewDialogResponse = {};

const ConanairManagementGridRowNewDialog: React.FC<ConanairManagementGridRowNewDialogProps> = (props: ConanairManagementGridRowNewDialogProps) => {
  const tableBaseStyle = TableUseStyle();
  const pageStyle = ConanairManagementStyle();
  const { t } = useTranslation();
  const { login } = useContext(AppContext);

  /** コナンエアーID */
  const [conanairId, setConanairId] = useState<string>('');
  /** 機器番号 */
  const [devNo, setDevNo] = useState<number>();
  /** 取付箇所 */
  const [itemName, setItemName] = useState<number>();
  /** 収集時刻 時 */
  const [logHour, setLogHour] = useState<string>('00');
  /** 収集時刻 分 */
  const [logMin, setLogMin] = useState<string>('00');
  /** 収集時刻 秒 */
  const [logSec, setLogSec] = useState<string>('00');

  const [isOpen, setOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);

  /** APIレスポンスダイアログ */
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showTitle, setShowTitle] = React.useState<string>('');
  const [showMessage, setShowMessage] = React.useState<string>('');

  useEffect(() => {
    /** 初期設定 */
    setDevNo(1);
    setItemName(1);
  }, []);

  /**
   * 収集時刻の設定
   * @param hour 
   * @param minute 
   * @param sec 
   */
  const GetLogStartItem = (hour: string, minute: string, sec: string): string => {
    let dateTimeNow = new Date;

    let year = dateTimeNow.getFullYear();
    let month = dateTimeNow.getMonth();
    let date = dateTimeNow.getDate();

    let logStartItem = new Date(year, month, date, Number(hour), Number(minute), Number(sec));
    console.debug(["GetLogStartItem", logStartItem])

    //現在時刻よりも収集時刻を後の時刻に設定
    return logStartItem > dateTimeNow ?
      dayjs(logStartItem).format('YYYY-MM-DD HH:mm:ss') :
      dayjs(logStartItem.setDate(logStartItem.getDate() + 1)).format('YYYY-MM-DD HH:mm:ss')
  }

  /**
   * キャンセル処理
   */
  const cancelAction = () => {
    console.debug('handleDialogConsole()');
    setOpen(false);
    setMode(false);
  };

  /**
  * 新規登録
  */
  const newBtnAction = () => {
    let conanData = {} as CONNAIR_SET;
    conanData.CNA_ID = conanairId;
    conanData.DEV_INDEX = devNo == undefined ? 0 : devNo;
    conanData.ITM_NAME_NO = itemName == undefined ? 0 : itemName;



    let colSetLogData = {} as ColSetLogModel;
    colSetLogData.LogStart = GetLogStartItem(logHour, logMin, logSec);

    let data = { ConanairSet: conanData, ColSetLog: colSetLogData } as ConanAirSetModel
    console.debug(['--- newBtnAction ---', data]);

    InsertConanAirManagement(data).then((status: number) => {
      console.debug(['status', status]);
      if (status == ApiResponseCode.SUCCESS) {
        /** 新規登録要求のレコード追加 新規登録非同期待ち */
        setOpen(false);
        setMode(true);
        return;
      }
      /** エラー */
      setShowTitle(t('ConanairManagementGridRowNewDialog.新規登録エラー', '新規登録エラー'));
      if (status == ApiResponseCode.BAD_REQUEST) {
        /** パラメータ異常時 */
        setShowMessage(t('ConanairManagementGridRowNewDialog.パラメータに誤りがあります', 'パラメータに誤りがあります'));
      } else if (status == ApiResponseCode.NOT_ACCEPTABLE) {
        /** 既に登録済み */
        setShowMessage(
          t(
            'ConanairManagementGridRowNewDialog.コナンエアIDか機器番号が既に登録済みです',
            '「コナンエアーID」か「機器番号」が既に登録済みです'
          )
        );
      } else if (login.IsIoT == true && status === ApiResponseCode.DEVINDEX_IOT_REGISTERED) {
        setShowMessage(
          t(
            'ConanairManagementGridRowNewDialog.既にTMBEE-BOX管理画面で登録済みの機器番号です',
            '既にTMBEE-BOX管理画面で登録済みの「機器番号」です'
          )
        );
      } else {
        /** 更新失敗時 */
        setShowMessage(t('ConanairManagementGridRowNewDialog.システムエラーが発生しました', 'システムエラーが発生しました'));
      }
      setMessageDialogOpen(true);
    });
  };
  console.debug(['- 画面描画開始 -', 'mode:', mode]);
  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {t('ConanairManagementGridRowNewDialog.コナンエアID新規登録', 'コナンエアーID新規登録')}
        </DialogTitle>
        <DialogContent>
          <TableContainer className={pageStyle.tableDialgContainer}>
            <Table aria-label="judgeSetting">
              <TableBody>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell} width={250}>
                    {t('ConanairManagementGridRowNewDialog.コナンエアID', 'コナンエアーID')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.bodyCellCenter} width={200}>
                    <input
                      className={tableBaseStyle.textField}
                      type="text"
                      maxLength={10}
                      defaultValue={conanairId}
                      value={conanairId}
                      onChange={(e) => {
                        const re = /^[a-zA-Z0-9!-/:-¥[-`{-~\b]+$/;
                        if (e.target.value === '' || re.test(e.target.value)) {
                          setConanairId(e.target.value);
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/* 機器番号 プルダウン */}
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('ConanairManagementGridRowNewDialog.機器番号', '機器番号')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.bodyCellCenter}>
                    <ItemComboBox
                      label=""
                      itemList={props.devNoComBox}
                      value={devNo}
                      onChangeEvent={(e) => {
                        console.debug(['onChangeEvent', e.target.value]);
                        if (typeof e.target.value === 'string') {
                          const val = parseInt(e.target.value);
                          setDevNo(val);
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/* 取付箇所 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('ConanairManagementGridRowNewDialog.取付箇所', '取付箇所')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.bodyCellCenter}>
                    <ItemComboBox
                      label=""
                      itemList={props.nameItemComBox}
                      value={itemName}
                      onChangeEvent={(e) => {
                        console.debug(['onChangeEvent', e.target.value]);
                        if (typeof e.target.value === 'string') {
                          const val = parseInt(e.target.value);
                          setItemName(val);
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/* 収集時刻 */}
                {login.IsIoT === true ?
                  <TableRow>
                    <TableCell className={tableBaseStyle.headerCell}>
                      {t('ConanairManagementGridRowNewDialog.収集時刻', '収集時刻')}
                    </TableCell>
                    <TableCell className={tableBaseStyle.bodyCellCenter}>
                      <div className={pageStyle.flexBox}>
                        <TimeEntry
                          value={logHour}
                          maxValue={23}
                          minValue={0}
                          onChange={(val) => {
                            setLogHour(val);
                          }}
                          className={tableBaseStyle.logTimeField}
                        />
                        :
                        <TimeEntry
                          value={logMin}
                          maxValue={59}
                          minValue={0}
                          onChange={(val) => {
                            setLogMin(val);
                          }}
                          className={tableBaseStyle.logTimeField}
                        />
                        :
                        <TimeEntry
                          value={logSec}
                          maxValue={59}
                          minValue={0}
                          onChange={(val) => {
                            setLogSec(val);
                          }}
                          className={tableBaseStyle.logTimeField}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                  : null
                }

              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={conanairId === ''}
            className={pageStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={(e) => {
              newBtnAction();
            }}
          >
            {t('ConanairManagementGridRowNewDialog.新規登録', '新規登録')}
          </Button>
          <Button
            className={pageStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={cancelAction}
          >
            {t('ConanairManagementGridRowNewDialog.キャンセル', 'キャンセル')}
          </Button>

        </DialogActions>
      </Dialog>
      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        title={showTitle}
        okText={'OK'}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
    </>
  );
};



export default ConanairManagementGridRowNewDialog;